import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text, TouchableOpacity, View } from "react-native";

import DependencyAvatarDetailCustom from "./DependencyAvatarDetailCustom";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

export default class DependencyItem extends React.Component {
  static propTypes = {
    fullName: PropTypes.string.isRequired,
    dependent: PropTypes.oneOf(["parents", "partner", "children"]).isRequired,
    onSelect: PropTypes.func.isRequired
  };

  render() {
    const { fullName, dependent, onSelect } = this.props;

    return (
      <View style={styles.container}>
        <DependencyAvatarDetailCustom
          fullName={fullName}
          dependent={dependent}
        />
         <TouchableOpacity onPress={() => {
          onSelect(dependent);
        }} style={styles.selectButton}>
          <Text style={styles.selectText}>{I18n.t("prixa.select")}</Text>
        </TouchableOpacity>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
    flexDirection: "row"
  },
  selectButton: {
    backgroundColor: staticColors.forestFern,
    borderRadius: 20,
    margin: 10,
    paddingHorizontal: 20,
    paddingVertical: 5
  },
  selectText: {
    color: staticColors.white,
    fontSize: 18,

    ...fonts.regular
  }
});
